
import { Component, Prop, Vue } from "vue-property-decorator";
import AdminBadge from "./AdminBadge.vue";
import { OFFER_STATES } from "@/helpers/admin-badges";

// Статус оффера цветным бейджем с номером: 3 — зелёный, 6/7 — красный и т.д.
@Component({ components: { AdminBadge } })
export default class AdminOfferStateBadge extends Vue {
  @Prop() value: number | string | undefined | null;

  get meta() {
    return (
      OFFER_STATES[String(this.value)] || {
        name: String(this.value),
        label: "Другой",
        color: "grey"
      }
    );
  }
}
